<template>
  <div
    id="app"
    :class="[{ collapsed: collapsed }, { 'is-mobile': isOnMobile }]"
  >
    <div class="c-topbar">
      <button
        type="button"
        class="button is-white"
        @click="onToggleCollapse(!collapsed)"
      >
        <b-icon icon="menu"></b-icon>
      </button>
      <div class="title is-5 has-text-weight-medium">
        {{ selectedMenu.title }}
      </div>
    </div>

    <div class="c-container">
      <router-view />
    </div>

    <sidebar-menu
      ref="sidebar"
      :menu="menu"
      :collapsed="collapsed"
      :theme="selectedTheme"
      :show-one-child="true"
      :hide-toggle="true"
      width="280px"
      :width-collapsed="isOnMobile ? '0' : '50px'"
      @toggle-collapse="onToggleCollapse"
      @item-click="onItemClick"
    />

    <div
      v-if="isOnMobile && !collapsed"
      class="sidebar-overlay"
      @click="collapsed = true"
    ></div>
  </div>
</template>

<script>
import { SidebarMenu } from "vue-sidebar-menu";
import CDialogPopup from "@/components/CDialogPopup";

export default {
  name: "AuthShell",
  components: { SidebarMenu },
  data() {
    return {
      selectedTheme: "default-theme",
      isOnMobile: true,
      collapsed: false,
      selectedMenu: "",
      menu: [
        {
          header: true,
          title: "Menu Utama"
        },
        {
          href: "/",
          title: "Dasbor",
          icon: "mdi mdi-view-grid-outline"
        },
        {
          href: "/attendance",
          title: "Absensi",
          icon: "mdi mdi-account-multiple-check-outline"
        },
        {
          href: "/announcement",
          title: "Pengumuman",
          icon: "mdi mdi-script-text-outline"
        },
        {
          header: true,
          title: "Master Data"
        },
        {
          href: "/employee",
          title: "Pegawai",
          icon: "mdi mdi-clipboard-account-outline"
        },
        {
          href: "/unit",
          title: "Unit Kerja",
          icon: "mdi mdi-office-building-marker-outline"
        },
        {
          href: "/question",
          title: "Pertanyaan",
          icon: "mdi mdi-comment-question-outline"
        },
        {
          header: true,
          title: "Lainnya"
        },
        {
          href: "/setting",
          title: "Pengaturan",
          icon: "mdi mdi-cog-outline"
        },
        {
          key: "logout",
          title: "Keluar",
          icon: "mdi mdi-logout"
        }
      ],
      themes: [
        {
          name: "Default theme",
          input: "default-theme"
        },
        {
          name: "White theme",
          input: "white-theme"
        }
      ]
    };
  },
  methods: {
    logout() {
      const loadingComponent = this.$buefy.loading.open();
      this.$auth.logout().then(async () => {
        loadingComponent.close();
      });
    },
    confirmLogout() {
      this.$buefy.modal.open({
        parent: this,
        animation: "zoom-out",
        events: {
          onPositiveAction: this.logout
        },
        props: {
          title: "Keluar",
          subtitle:
            "Apakah Anda yakin ingin keluar? Anda dapat masuk kembali nanti.",
          positiveLabel: "Keluar",
          negativeLabel: "Batal"
        },
        component: CDialogPopup
      });
    },
    onToggleCollapse(collapsed) {
      this.collapsed = collapsed;
    },
    onItemClick(event, item) {
      if (this.isOnMobile) {
        this.collapsed = true;
      }

      if (item.key === "logout") {
        setTimeout(this.confirmLogout, this.isOnMobile ? 250 : 0);
      }
    },
    onResize() {
      this.isOnMobile = window.innerWidth <= 767;
      this.collapsed = window.innerWidth <= 1023;
    },
    matchExactRoute() {
      for (let i = 0; i < this.menu.length; i++) {
        if (this.menu[i].header || !this.menu[i].href || this.menu[i].component)
          continue;

        const href = this.menu[i].href;
        let isExactRoute = false;

        if (this.$router) {
          const { route } = this.$router.resolve(href);
          isExactRoute = route.fullPath === this.$route.fullPath;
        } else {
          isExactRoute =
            href ===
            window.location.pathname +
              window.location.search +
              window.location.hash;
        }

        if (isExactRoute) {
          this.selectedMenu = this.menu[i];
          break;
        }
      }
    },
    addSidebarHeader() {
      const listEl = this.$refs.sidebar.$el.children[0].children[0];
      const headerEl = document.createElement("div");
      const textEl = document.createElement("span");
      const abbrTextEl = document.createElement("span");
      const iconEl = document.createElement("i");
      textEl.innerText = process.env.VUE_APP_NAME;
      abbrTextEl.innerText = this.getUpperLetters(textEl.innerText);
      iconEl.classList.add("mdi");
      iconEl.classList.add("mdi-square-rounded");
      textEl.classList.add("c-title");
      abbrTextEl.classList.add("c-title-abbr");
      headerEl.classList.add("c-sidebar-header");
      headerEl.prepend(abbrTextEl);
      headerEl.prepend(textEl);
      headerEl.prepend(iconEl);
      listEl.prepend(headerEl);
    }
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
    window.addEventListener("hashchange", this.matchExactRoute);

    this.onResize();
    this.matchExactRoute();
    this.addSidebarHeader();
  },
  destroyed() {
    if (!this.$router) {
      window.removeEventListener("resize", this.onResize);
      window.removeEventListener("hashchange", this.matchExactRoute);
    }
  },
  watch: {
    $route() {
      this.matchExactRoute();
    }
  }
};
</script>

<style lang="scss">
.c-topbar {
  padding: 0.5rem 0.5rem;
  border-bottom: 1px solid $grey-lightest;
  display: flex;
  align-items: center;
}

.c-topbar .title {
  display: inline-block;
  margin-left: 0.5rem;
}

#app {
  padding-left: 280px;
  transition: 0.3s ease;
}

#app.collapsed {
  padding-left: 50px;
}

#app.is-mobile {
  padding-left: 0;
}

.sidebar-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: $black;
  opacity: 0.5;
}

pre {
  font-family: Consolas, monospace;
  color: #000;
  background: #fff;
  border-radius: 2px;
  padding: 15px;
  line-height: 1.5;
  overflow: auto;
}

.v-sidebar-menu {
  background: linear-gradient(30deg, $primary-dark, $primary);
  z-index: 10 !important;
}

.v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active,
.v-sidebar-menu .vsm--link_level-1.vsm--link_active {
  -webkit-box-shadow: 3px 0 0 0 $white inset !important;
  box-shadow: 3px 0 0 0 $white inset !important;
  background-color: $primary;
}

.sidebar-overlay {
  z-index: 9 !important;
}

.v-sidebar-menu .vsm--icon {
  font-size: 22px;
}

.v-sidebar-menu .vsm--link_level-1 .vsm--icon {
  background-color: unset !important;
}

.v-sidebar-menu .vsm--link.vsm--link_hover:not(:hover) {
  background-color: unset !important;
}

.v-sidebar-menu .vsm--scroll-wrapper {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.v-sidebar-menu .vsm--list .c-sidebar-header {
  display: block;
  font-size: 14px;
  font-weight: 600;
  margin: 18px 10px;
  color: $white;
  text-transform: uppercase;
  white-space: nowrap;
}

.v-sidebar-menu .vsm--list .c-sidebar-header .c-title {
  margin-left: 0.5rem;
}

.v-sidebar-menu .vsm--list .c-sidebar-header .c-title-abbr {
  display: none;
}

#app.collapsed:not(.is-mobile) .v-sidebar-menu .c-sidebar-header {
  text-align: center;
}

#app.collapsed:not(.is-mobile) .v-sidebar-menu .c-sidebar-header .c-title,
#app.collapsed:not(.is-mobile) .v-sidebar-menu .c-sidebar-header i {
  display: none;
}

#app.collapsed:not(.is-mobile) .v-sidebar-menu .c-sidebar-header .c-title-abbr {
  display: block;
}

.v-sidebar-menu .vsm--list {
  padding: 0 !important;
}

.v-sidebar-menu .vsm--header {
  font-size: 12px !important;
  font-weight: 500 !important;
  opacity: 0.4;
}

#app .v-sidebar-menu .vsm--header {
  transition: 0.3s ease;
}

#app.collapsed:not(.is-mobile) .v-sidebar-menu .vsm--header {
  height: 0;
  overflow: hidden;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
